export const Route = {
  MAIN: '/',
  SIGN_IN: '/sign-in',
  UNMAPPED_GAMES: '/unmapped-games',
  ALIASES: '/aliases',
  POSSIBLE_ALIASES: '/possible-aliases',
  GAMES: '/games',
  MAPPED_PROMO_GAMES: '/mapped-promo-games',
  UNMAPPED_PROMO_GAMES: '/unmapped-promo-games',
  LLM_GAME_MATCHING: '/llm-game-matching',
  NOT_FOUND: '*',
} as const;

export const isLlmGameMatchingAvailable = import.meta.env.VITE_PROJECT_ENV !== 'development';
